import { ReactNode } from "react";
import { classNames } from "../../UI/Utils/classNames.ts";

export function StatsKpi({
  label,
  value,
  sub,
  highlight,
}: {
  label: string;
  value: ReactNode;
  sub: ReactNode;
  highlight?: boolean;
}) {
  return (
    <div
      className={classNames(
        "rounded-lg p-4 flex flex-col gap-1",
        highlight ? "bg-primary text-white" : "bg-white",
      )}
    >
      <span
        className={classNames(
          "text-xs font-medium",
          highlight ? "text-blue-200" : "text-gray-500",
        )}
      >
        {label}
      </span>
      <span className="text-2xl font-semibold tabular-nums">{value}</span>
      <span
        className={classNames(
          "text-xs",
          highlight ? "text-blue-200" : "text-gray-400",
        )}
      >
        {sub}
      </span>
    </div>
  );
}
